import 'primereact/resources/themes/md-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './styles/index.scss';

import ReactDOM from 'react-dom/client';

import './index.css';
import { RouterProvider } from 'react-router-dom';
import './i18n';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { store } from './app/modules/redux/store/GlobalStore';
import { GetSentryEnvironment } from './app/modules/core/utils/GetSentryEnvironment';
import { GLOBAL } from './app/modules/core/constants/Global';
import ReactGA from 'react-ga4';
import { Auth0Provider } from '@auth0/auth0-react';

import { ROUTER } from './Router';

Sentry.init({
	dsn: GLOBAL.SENTRY_URL,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration({
			maskAllText: true,
			blockAllMedia: true,
		}),
	],
	environment: GetSentryEnvironment(),
	tracesSampleRate: 1.0,
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,
	// If the entire session is not sampled, use the below sample rate to sample
	// sessions when an error occurs.
	replaysOnErrorSampleRate: 1.0,
});

ReactGA.initialize(GLOBAL.GA_KEY ?? '', {
	gaOptions: {
		apiVersion: 4,
	},
	testMode: true,
});
ReactGA.send({ hitType: 'pageview', page: window.location.pathname });

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<Provider store={store}>
		<Auth0Provider
			domain={process.env.AUTH_PROVIDER_DOMAIN as any}
			clientId={process.env.AUTH_PROVIDER_CLIENT_ID as any}
			authorizationParams={{
				ui_locales: 'pt-BR',
				redirect_uri: window.location.origin,
			}}
		>
			<RouterProvider router={ROUTER} />
		</Auth0Provider>
	</Provider>
);
